import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import "./header.css";
import { useForm } from "react-hook-form";
import axios from "axios";
import swal from "sweetalert";
import PopupMenu from "./PopupMenu";

const Header = () => {
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );
    const navigate = useNavigate();
    const location = useLocation();
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [notify, setNotify] = useState(JSON.parse(localStorage.getItem("notify")));
    const [setting, setSetting] = useState(JSON.parse(localStorage.getItem("setting")));
    const [isOpen, setIsOpen] = useState(false);
    const [menu, setMenu] = useState(null);
    const openPopup = (num) => {
        setMenu(num);
        setIsOpen(true);
    };
    const closePopup = () => {
        setIsOpen(false);
    };
    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm();
    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (profile != res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => localStorage.removeItem("user"));
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getnotify`, {}).then((res) => {
            if (notify != res.data.data) {
                setNotify(res.data.data);
                localStorage.setItem("notify", JSON.stringify(res.data.data));
            }
        });
        axios.get(`${process.env.REACT_APP_API_URL}/setting/get`, {}).then((res) => {
            if (setting != res.data.data[0]) {
                setSetting(res.data.data[0]);
                localStorage.setItem("setting", JSON.stringify(res.data.data[0]));
            }
        });
    }, []);
    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/casino/create`);
    }, [profile]);
    /*useEffect(() => {
        const interval = setInterval(() => {
            axios
                .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
                .then((res) => {
                    if (profile != res.data.data) {
                        setProfile(res.data.data);
                        localStorage.setItem("profile", JSON.stringify(res.data.data));
                    }
                })
                .catch((err) => localStorage.removeItem("user"));
        }, 5000);
        return () => clearInterval(interval);
    }, []);*/
    const onSubmit = async (data) => {
        const regex = /^[a-zA-Z0-9]+$/;
        if (data.username.length < 6) {
            swal("Thông báo", "Tên đăng nhập tối thiểu 6 kí tự", "warning");
            return;
        }
        if (!regex.test(data.username)) {
            swal("Thông báo", "Tên đăng nhập không chứa khoảng trắng và ký tự đặc biệt", "warning");
            return;
        }
        if (data.password.length < 6) {
            swal("Thông báo", "Mật khẩu tối thiểu 6 kí tự", "warning");
            return;
        }
        axios
            .post(`${process.env.REACT_APP_API_URL}/auth/login`, {
                username: data.username.toLowerCase(),
                password: data.password
            })
            .then((res) => {
                swal({
                    title: "Thông báo",
                    text: "Đăng nhập thành công",
                    icon: "success",
                    buttons: "Đồng ý"
                }).then(() => {
                    localStorage.removeItem("user");
                    localStorage.removeItem("profile");
                    localStorage.removeItem("data");
                    localStorage.setItem("user", res.data.data);
                    window.location.href = "/";
                });
            })
            .catch((err) => swal("Thông báo", err.response.data.message ? err.response.data.message : "Tên đăng nhập hoặc mật khẩu không chính xác!", "error"));
    };
    const data = [
        {
            title: "Trang Chủ",
            sub: "Home",
            to: "/"
        },
        {
            title: "Xổ Số",
            sub: "Lottery",
            to: "/lottery"
        },
        {
            title: "Bắn Cá",
            sub: "Fishing",
            to: "/fishing"
        },
        {
            title: "Casino",
            sub: "Live Casino",
            to: "/casino"
        },
        {
            title: "Game Bài",
            sub: "PVP",
            to: "/pvp"
        },
        {
            title: "Nổ Hũ",
            sub: "Slot",
            to: "/slots"
        },
        {
            title: "Thể Thao",
            sub: "Sports",
            to: "/sports"
        },
        {
            title: "Khuyến mãi",
            sub: "Promotion",
            to: "/promotion"
        }
    ];
    const logOut = () => {
        localStorage.removeItem("user");
        localStorage.removeItem("currentUser");
        localStorage.removeItem("profile");
        localStorage.removeItem("data");
        localStorage.removeItem("data1");
        var now = new Date();
        var time = now.getTime();
        var expireTime = time;
        now.setTime(expireTime);
        document.cookie = "jwt=;Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
        window.location.href = "/";
    }
    const getProfile = () => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (profile != res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => localStorage.removeItem("user"));
    };
    return (
        <>
            <header>
                <div className="topbar_bg">
                    <div className="container">
                        <div className="topbar">
                            <div className="topbar_left">
                                <ul>
                                    <li>
                                        <Link to="/lottery">VN Lottery</Link>
                                    </li>
                                    <li>
                                        <Link to="/slots">GPI nổ hũ</Link>
                                    </li>
                                    <li>
                                        <Link to="/sports">Saba Sport</Link>
                                    </li>
                                    <li>
                                        <a href={setting?.down_link} target="_blank">Tải App</a>
                                    </li>
                                </ul>
                            </div>
                            <div className="topbar_right">
                                <div className="topbar_app">
                                    <ul>
                                        <li>
                                            <a href={setting?.down_link} target="_blank">App di động</a>
                                        </li>
                                        <li className="license">
                                            <span>Hiển thị Giấy phép</span>
                                            <div className="license-img">
                                                <img src={require("../../image/license-img.png")} alt="" />
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="header">
                    <div className="container">
                        <div className="main_header d-flex">
                            <div className="logo">
                                <Link to="/">
                                    <img alt="" src={require("../../image/logo.png")} />
                                </Link>
                            </div>
                            <div className="main_menu">
                                <nav>
                                    <ul>
                                        {data.map((item, index) => (
                                            <li className={location.pathname === item.to ? "menu_item active" : "menu_item"} key={index}>
                                                <Link to={item.to}>
                                                    <div className="item_title">{item.title}</div>
                                                    <div className="item_sub">{item.sub}</div>
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="menu_login">
                    <div className="container d-flex">
                        {profile ? (
                            <>
                                <div className="title-login">
                                    <span className="title-login-icon">
                                        <svg className="svg-icon">
                                            <use xlinkHref="#icon-username"></use>
                                        </svg>
                                    </span>
                                    <span>{profile?.username}</span>
                                </div>
                                <div className="menu-login">
                                    <ul>
                                        <li>
                                            Số dư: <span style={{ fontWeight: "bold" }}>{Math.floor(profile?.money).toLocaleString()}</span>
                                        </li>
                                        <li onClick={() => openPopup(1)} className="item">
                                            <span>Tài khoản</span>
                                        </li>
                                        <li onClick={() => openPopup(2)} className="item">
                                            <span>Nạp tiền</span>
                                        </li>
                                        <li onClick={() => openPopup(3)} className="item">
                                            <span>Rút tiền</span>
                                        </li>
                                        <li onClick={() => openPopup(7)} className="item">
                                            <span>Quy đổi</span>
                                        </li>
                                        <li onClick={() => openPopup(4)} className="item">
                                            <span>Lịch sử trò chơi</span>
                                        </li>
                                        <li onClick={logOut} className="item">
                                            <span>Đăng xuất</span>
                                        </li>
                                    </ul>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="title-login">
                                    <span className="title-login-icon">
                                        <svg className="svg-icon">
                                            <use xlinkHref="#icon-username"></use>
                                        </svg>
                                    </span>
                                    <span>Đăng Nhập</span>
                                </div>
                                <div className="box-login">
                                    <form onSubmit={handleSubmit(onSubmit)}>
                                        <div className="formlogin d-flex">
                                            <div className="form-group input-username">
                                                <input type="text" {...register("username")} placeholder="Tên đăng nhập" />
                                            </div>
                                            <div className="form-group input-password">
                                                <input type="password" {...register("password")} placeholder="Mật khẩu" />
                                            </div>
                                            <div>
                                                <button type="submit">Đăng nhập</button>
                                            </div>
                                            <div>
                                                <Link to="/register" className="btn">
                                                    Đăng ký
                                                </Link>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </>
                        )}
                    </div>
                </div>
                {notify ? (
                    <>
                        {notify[0].isShow === true && notify[0].title === "marquee" ? (
                            <div className="header-notify">
                                <div className="container d-flex">
                                    <div className="notify-title">
                                        <i className="icon_news"></i>
                                        Thông báo hệ thống
                                    </div>
                                    <marquee>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: notify[0].content
                                            }}
                                        />
                                    </marquee>
                                </div>
                            </div>
                        ) : null}
                    </>
                ) : null}
            </header>
            <PopupMenu profile={profile} isOpen={isOpen} isClose={closePopup} menuActive={menu} getProfile={getProfile}/>
        </>
    );
};

export default Header;
